import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { UIRouterModule } from '@uirouter/angular';
import { STATES } from './home.states';
import { GlobalModule } from '../global/global.module';

@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    GlobalModule,
    UIRouterModule.forChild({states: STATES})
  ],
  providers: [
  ]
})
export class HomeModule {
}



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts